import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  resetErrors,
  changeFormStep,
  updateOrCreateRequest,
  getDishes,
  deleteDishes,
  getByIdRequest,
  resetListData as resetListDataAction,
  changeDishPosition,
} from './actions';
import {
  dishesListDataSelector,
  dishesStepSelector,
  dishesCompletedStepsSelector,
  dishItemLoadingSelector,
  dishItemSelector,
  createOrUpdateInProcessSelector,
  createOrUpdateErrorsSelector,
  deleteInProcessSelector,
} from './selectors';

import { dishesSteps } from 'common/constants/menu';

export const useDishes = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const listData = useSelector(dishesListDataSelector);
  const currentItem = useSelector(dishItemSelector);
  const itemLoading = useSelector(dishItemLoadingSelector);
  const step = useSelector(dishesStepSelector);
  const completedSteps = useSelector(dishesCompletedStepsSelector);
  const createOrUpdateInProcess = useSelector(createOrUpdateInProcessSelector);
  const createOrUpdateErrors = useSelector(createOrUpdateErrorsSelector);
  const deleteInProcess = useSelector(deleteInProcessSelector);

  const handleChangeDishStep = (nextStep) => {
    dispatch(
      changeFormStep({
        step: nextStep,
        completedSteps: [...completedSteps, nextStep],
      }),
    );
  };

  const handleGetDishes = () => {
    dispatch(getDishes({}));
  };

  const handleGetDishById = (id) => {
    dispatch(getByIdRequest({ id }));
  };

  const handleChangeDishPosition = (id, position, originalPosition) => {
    dispatch(changeDishPosition({ id, position, originalPosition }));
  };

  const resetListData = () => {
    dispatch(resetListDataAction());
  };

  const handleResetErrors = () => {
    if (createOrUpdateErrors) {
      dispatch(resetErrors());
    }
  };

  const handleUpdateOrCreate = (data, id) => {
    dispatch(updateOrCreateRequest({ formData: data, history, id }));
  };

  const handleResetSteps = () => {
    dispatch(
      changeFormStep({
        step: dishesSteps.first,
        completedSteps: [dishesSteps.first],
      }),
    );
  };

  const handleDeleteDish = (id) => {
    dispatch(deleteDishes({ id, history }));
  };

  return {
    handleResetErrors,
    listData,
    handleChangeDishStep,
    step,
    completedSteps,
    itemLoading,
    currentItem,
    createOrUpdateInProcess,
    createOrUpdateErrors,
    handleUpdateOrCreate,
    handleGetDishes,
    handleResetSteps,
    handleDeleteDish,
    handleGetDishById,
    deleteInProcess,
    resetListData,
    handleChangeDishPosition,
  };
};
